import React from "react";
import { Ring } from "react-awesome-spinners";

import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader">
      <Ring />
      <h3>جاري تحميل البيانات</h3>
    </div>
  );
};

export default Loader;
